import { render, staticRenderFns } from "./WorkGroupIndex.vue?vue&type=template&id=09a9b4ec&"
import script from "./WorkGroupIndex.vue?vue&type=script&lang=js&"
export * from "./WorkGroupIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports